import React, { useEffect, useState } from "react";
import { Star, Power } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const FEATURES = ["MYEVENT","MYPLANNING","MYGUESTS","MYPRO","MYMEMORIES","MYWALLET","MYMUSIC","MYASSISTANT","MYLIVE"];

export default function MyAdminPlans() {
  const [plans, setPlans] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/myadmin/plans").then(r => setPlans(r.data.plans));
  useEffect(() => { load(); }, []);

  const toggle = async (id) => {
    await api.post(`/myadmin/plans/${id}/toggle`);
    await load();
    toast.success("Statut mis à jour");
  };
  const save = async (p) => {
    const { plan_features, id, created_at, updated_at, ...body } = p;
    await api.patch(`/myadmin/plans/${id}`, body);
    await load();
    setEditing(null);
    toast.success("Forfait sauvegardé");
  };
  const toggleFeature = async (planId, feature_key, currentEnabled) => {
    const p = plans.find(pl => pl.id === planId);
    const existing = (p?.plan_features || []).find(f => f.feature_key === feature_key);
    await api.put(`/myadmin/plans/${planId}/features/${feature_key}`, {
      feature_key, tier: existing?.tier || "basic", enabled: !currentEnabled,
    });
    await load();
    toast.success("Fonctionnalité mise à jour");
  };

  return (
    <div data-testid="myadmin-plans">
      <header className="mb-6"><p className="eyebrow">MyAdmin</p><h1 className="font-serif-luxe text-4xl mt-3">Forfaits & <span className="italic gold-text">Tarifs.</span></h1></header>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {plans.map(p => (
          <div key={p.id} data-testid={`plan-${p.slug}`} className={`card-luxe p-6 ${!p.active ? "opacity-50" : ""}`}>
            <div className="flex items-start justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <h3 className="font-serif-luxe text-2xl">{p.name}</h3>
                  {p.highlighted && <Star size={14} className="text-[#DCB457]" fill="#DCB457" />}
                </div>
                <p className="text-[11px] uppercase tracking-widest text-white/40 mt-1">{p.slug}</p>
              </div>
              <button onClick={() => toggle(p.id)} data-testid={`plan-toggle-${p.slug}`} title={p.active ? "Désactiver" : "Activer"} className={`p-2 border ${p.active ? "border-[#DCB457]/40 text-[#DCB457]" : "border-white/20 text-white/40"} hover:bg-white/5`}><Power size={14} /></button>
            </div>
            <p className="font-serif-luxe text-4xl gold-text mb-2">{p.price > 0 ? `${p.price} €` : "Sur devis"}</p>
            <p className="text-sm text-white/65 leading-relaxed mb-4">{p.description}</p>
            <div className="border-t border-[#DCB457]/15 pt-4">
              <p className="text-[10px] uppercase tracking-widest text-white/45 mb-2">Fonctionnalités</p>
              <div className="flex flex-wrap gap-1.5">
                {FEATURES.map(fk => {
                  const f = (p.plan_features || []).find(x => x.feature_key === fk);
                  const enabled = f?.enabled ?? false;
                  return (
                    <button key={fk} data-testid={`feature-${p.slug}-${fk}`} onClick={() => toggleFeature(p.id, fk, enabled)} className={`text-[10px] uppercase tracking-widest px-2 py-1 border ${enabled ? "border-[#DCB457]/60 text-[#DCB457] bg-[#DCB457]/10" : "border-white/15 text-white/35"}`}>{fk.replace("MY", "")}{f?.tier === "advanced" ? "+" : ""}</button>
                  );
                })}
              </div>
            </div>
            <div className="mt-4 flex gap-2">
              {editing?.id === p.id ? (
                <>
                  <input type="number" step="1" value={editing.price} onChange={(e) => setEditing({ ...editing, price: parseFloat(e.target.value) || 0 })} className="bg-black/40 border border-[#DCB457]/25 text-white p-2 text-sm w-24" data-testid={`plan-price-input-${p.slug}`} />
                  <button onClick={() => save(editing)} data-testid={`plan-save-${p.slug}`} className="px-3 py-2 bg-[#DCB457] text-black text-xs uppercase tracking-widest">Enregistrer</button>
                  <button onClick={() => setEditing(null)} className="px-3 py-2 border border-white/20 text-white/60 text-xs uppercase tracking-widest">Annuler</button>
                </>
              ) : (
                <button onClick={() => setEditing({ ...p })} data-testid={`plan-edit-${p.slug}`} className="text-xs uppercase tracking-widest text-white/60 hover:text-[#DCB457]">Modifier</button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
